import React from 'react';
var AkStatusLozenge = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/lozenge');
});
var StatusLozenge = function StatusLozenge(_ref) {
  var appearance = _ref.appearance,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(AkStatusLozenge, {
    appearance: appearance
  }, text);
};
export default StatusLozenge;
export var StatusLozengeFn = function StatusLozengeFn(_ref2) {
  var props = _ref2.props;
  var _ref3 = props,
    appearance = _ref3.appearance,
    text = _ref3.text;
  return /*#__PURE__*/React.createElement(StatusLozenge, {
    appearance: appearance,
    text: text
  });
};